import { useField, useFormikContext } from 'formik'
import { Input } from 'almanac-ui/TextInputField/Input'
import { InputProps } from 'almanac-ui/TextInputField/Types'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import { forwardRef } from 'react'

interface Props extends Omit<InputProps, 'value'> {
  variant?: 'default' | 'grey'
}

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ name, isTextarea = true, variant = 'default', ...props }, ref) => {
    const { status } = useFormikContext()
    const [field, meta] = useField(name)
    const { touched, error } = meta

    if (status === FormStatus.AutoFilling) {
      return <TextFieldLoadingState />
    }

    return (
      <Input
        {...props}
        isTextarea={isTextarea}
        isValid={touched ? !error : true}
        size="lg"
        name={field.name}
        value={field.value}
        onChange={field.onChange}
        aria-label={field.name}
        ref={ref}
        variant={variant}
      />
    )
  },
)
